import { Box, Button, Paper, Stack, Typography } from '@mui/material';
import React from 'react';
import type { RegistryMe } from '../api/registryApiTypes';

export function unavailableReason(me: RegistryMe): string {
  if (!me.enabled) {
    return 'The Registry is switched off for this environment. An admin can turn it on in Global Configuration.';
  }
  return 'Your admin account does not have the Registry View permission. Ask an admin who manages admin users to grant it on the admin portal’s permissions screen.';
}

export default function RegistryUnavailable({
  me,
  onSignOut,
}: {
  me: RegistryMe;
  onSignOut: () => void;
}) {
  return (
    <Box sx={{ minHeight: '100vh', display: 'grid', placeItems: 'center', p: 2 }}>
      <Paper variant="outlined" sx={{ p: 4, maxWidth: 520 }}>
        <Typography variant="h5" component="h1" gutterBottom>
          Registry not available
        </Typography>
        <Typography variant="body1" sx={{ mb: 1 }}>
          {unavailableReason(me)}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Signed in as {me.user.name} ({me.user.email}).
        </Typography>
        <Stack direction="row" spacing={1} sx={{ mt: 3 }}>
          <Button variant="outlined" onClick={() => window.location.reload()}>
            Try again
          </Button>
          <Button onClick={onSignOut}>Sign out</Button>
        </Stack>
      </Paper>
    </Box>
  );
}
